function moveCarousel(direction) {
    const carousel = document.getElementById('upsellCarousel');
    const cardWidth = carousel.querySelector('.upsell-product-card')?.offsetWidth || 360;
    carousel.scrollLeft += direction * (cardWidth + 16);
}
function openSwatchModal(el) {
    const productId = el.getAttribute('data-product-id');
    const modalOverlay = document.querySelector(`.swatches-modal-overlay[data-product-id='${productId}']`);
    if (modalOverlay) {
      modalOverlay.style.display = 'flex';
    }
}

document.addEventListener('click', function (e) {

    if (e.target.closest('.upsell-content-shade')) {
        const trigger = e.target.closest('.upsell-content-shade');
        openSwatchModal(trigger);
    }

    if (e.target.classList.contains('modal-swatch')) {
        const swatch = e.target;
        if (swatch.classList.contains('unavailable-swatch')) {
            return;
        }
        const shade = swatch.getAttribute('data-variant-shade');
        const productId = swatch.closest('.swatches-modal-side-cart').getAttribute('data-product-id');
        const modalOverlay = document.querySelector(`.swatches-modal-overlay[data-product-id='${productId}']`);
        const variantId = swatch.getAttribute('data-variant-id');
        const variantPrice = swatch.getAttribute('data-variant-price');

        const swatches = swatch.parentElement.querySelectorAll('.modal-swatch');
        swatches.forEach(el => el.removeAttribute('data-active'));
        swatch.setAttribute('data-active', 'true');

        if (modalOverlay) modalOverlay.style.display = 'none';

        const shadeLabel = document.querySelector(`.upsell-content-shade[data-product-id='${productId}'] .upsell-shade-selected`);
        const shadeLabelModal = document.querySelector(`.upsell-shade-side-cart[data-product-id='${productId}']`);
        const subtitle = swatch.getAttribute('data-variant-subtitle');
        if (shadeLabel) {
            const baseText = "Shade: ";
            shadeLabel.textContent = subtitle ? `${baseText}${shade} ${subtitle}` : `${baseText}${shade}`;
        }
        if (shadeLabelModal) {
            const baseText = "Shade: ";
            shadeLabelModal.textContent = subtitle ? `${baseText}${shade} ${subtitle}` : `${baseText}${shade}`;
        }

        const card = document.querySelector(`.upsell-product-card[data-product-id='${productId}']`);
        if (card) {
            const btn = card.querySelector('button.ajax-cart-upsell-btn');
            const priceEl = card.querySelector('.upsell-price');
            if (btn) {
                btn.disabled = false;
                btn.setAttribute('onclick', `window.ajaxCartAddVariant(${variantId})`);
            }
            if (priceEl && variantPrice) {
                priceEl.textContent = variantPrice;
            }
        }
    }
    if (e.target.classList.contains('swatches-modal-overlay')) {
        e.target.style.display = 'none';
    }
});